GameView    = require "views/base/game"
{ DraggyView }  = require("views/components/draggy")
SmoothLine  = require("lib/draw/smooth-line")
easie       = require("lib/easie")
animate     = require("lib/animate")
{ dpi }     = require("lib/device")

class CircleTheAnswerView extends GameView
  template: require("./template")

  events: ->
    "iostap .btn-done": "endGame"

  serialize: ->
    d = super

    allAnswers   = d.metadata?.questions?[0]?.answers or []
    answers = allAnswers.map (a, i) ->
      id:        a.id
      text:      typogr.typogrify(a.content.toString() or "")
      isCorrect: a.correct
      delay:     4 + i * 2

    d.allAnswers = _.shuffle(answers)
    d

  show: ->
    super
    @setEl @findAll(".circle-box"), "boxes"

    @draggy = new DraggyView
      el: @findOne("canvas")
      isParent: true

    @context = @draggy.el.getContext?("2d") or {}

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop
    @listenTo this, "resize", @onResize

    @onResize()

    @context.clearRect?(0, 0, @draggy.el.width, @draggy.el.height)
    el.classList.remove("active", "complete") for el in @getEl("boxes")

    @enterGame()

  onResize: ->
    if el = @draggy?.el
      el.width  = @el.firstChild.offsetWidth * dpi
      el.height = @el.firstChild.offsetHeight * dpi

  onDrag: (draggy, isInitial) ->
    window.clearTimeout @timeout
    { left, top } = @getBounds(@el.firstChild)

    if isInitial
      @line?.animation?.cancel()
      @animation?.cancel()
      @context.lineCap = "round"
      @context.globalAlpha = 1
      @line = new SmoothLine([], window.getComputedStyle(@el).color, 4 * dpi)
      @activeBox = null

      for box in @getEl("boxes")
        box.classList.remove("active")

    @addPoint(draggy)

  onDrop: ->
    @findAnswer(@line.getPoints())

    if @activeBox
      @setState("touched")
    else
      @setState("prompt")

  addPoint: ({x, y}) ->
    @line.add x: x * dpi, y: y * dpi
    @drawLines()

  drawLines: ->
    @draggy.el.offsetHeight
    @context.clearRect(0, 0, @draggy.el.width, @draggy.el.height)
    @context.beginPath()
    @line.draw(@context)

  getClosestBox: (centerX, centerY) ->
    offset = x: -@draggy.offset.left, y: -@draggy.offset.top
    _.sortBy(@getEl("boxes"), (box) =>
      bounds = @getBounds(box, offset)
      x = (bounds.left + bounds.width / 2) - centerX / dpi
      y = (bounds.top + bounds.height / 2) - centerY / dpi
      Math.sqrt(x * x + y * y)
    )[0]

  getDistance: (p1, p2) ->
    distX = p1.x - p2.x
    distY = p1.y - p2.y
    Math.sqrt(Math.pow(distX, 2) + Math.pow(distY, 2))

  findAnswer: (points) ->
    minX = minY = Infinity
    maxX = maxY = -Infinity

    for { x, y } in points
      minX = x if x < minX
      maxX = x if x > maxX
      minY = y if y < minY
      maxY = y if y > maxY

    buffer  = 80
    centerX = _.average(_.pluck(points, "x"))
    centerY = _.average(_.pluck(points, "y"))
    radius  = ((maxX - minX) / 2 + (maxY - minY) / 2) / 2

    el = @getClosestBox(centerX, centerY)
    offset = x: -@draggy.offset.left, y: -@draggy.offset.top
    bounds = @getBounds(el, offset)
    boxX = bounds.left + bounds.width / 2
    boxY = bounds.top + bounds.height / 2

    isACircle = @getDistance(points[0], _.last(points)) < 250
    isWithin  = boxX * dpi > minX - buffer and boxX * dpi < maxX + buffer and
                boxY * dpi > minY - buffer and boxY * dpi < maxY + buffer

    @activeBox = if isACircle and isWithin then el
    @activeBox?.classList.add("active")

    type = if not isACircle then "line" else if isWithin then "on" else "off"
    @animateAnswer(type, centerX, centerY, radius)

  animateAnswer: (type, x, y, radius) ->
    switch type
      when "line"
        @line.erase @context, =>
          @context.clearRect(0, 0, @draggy.el.width, @draggy.el.height)

      when "on"
        duration = 1000
        @context.fillStyle = window.getComputedStyle(@el).color
        draw = (dist) =>
          scale = easie.elasticInOut(dist + 1, 0, 1.25, 2, 1.25, 1.25)
          @context.arc(x, y, radius * scale, 0, 2 * Math.PI)
          @context.fill()

      when "off"
        duration = 1000
        draw = (dist) =>
          scale = easie.elasticIn(1 - dist, 0.8, 0.2, 1, 0.5)
          @context.arc(x, y, radius * scale, 0, 2 * Math.PI)
          @context.stroke()

    if draw
      wrap = (d) =>
        @context.clearRect(0, 0, @draggy.el.width, @draggy.el.height)
        @context.beginPath()
        @context.globalAlpha = 1 - d
        draw(d)

      @animation = animate(wrap, duration)

  isCorrect: ->
    @activeBox?.dataset.correct?

  isMatch: (left, right) ->
    lr = @options.data.pairs[+left.dataset.index].right
    rr = @options.data.pairs[+right.dataset.index].right
    ll = @options.data.pairs[+left.dataset.index].left
    rl = @options.data.pairs[+right.dataset.index].left
    lr is rr or ll is rl

  endGame: ->
    super

    @submit()

  answerDetails: ->
    questions = @options.metadata?.questions or []
    return [] unless questions.length > 0

    question = questions[0]
    id       = @$(@activeBox).data("answer-id")
    details =
      answer: _.find(question.answers, { id })
      question: question.question

    [ details ]

module.exports = CircleTheAnswerView
